module.exports = __webpack_public_path__ + "img/dm.3a68c10.svg";